import Environment from './environment';

/**
 * アンカーリンク関連の処理
 */
export default class Anchor {
  constructor() {
    this.smoothScroll();
    this.tableContentsScroll();
  };

  /**
   * スムーススクロール
   */
  smoothScroll() {
    $('a[href^="#"]').click(function () {
      let href = $(this).attr('href');
      const target = $(href == '#' || href == '' ? 'html' : href);
      let position = 0;
      let deviceType = Environment.getDeviceType();
      if ($(this).hasClass('ez-toc-link') && deviceType == 'pc') { // 目次の場合でかつPCの場合
        position = target.offset().top - 180;
      } else if ($(this).hasClass('ez-toc-link') && deviceType == 'sp') { // 目次の場合でかつSPの場合
        position = target.offset().top - $('.l-header').outerHeight();
      } else {
        position = target.offset().top;
      }
      const speed = 500;
      $('html, body').animate({
        scrollTop: position
      }, speed, 'swing');
      return false;
    });
  };

  /**
   * アンカーリンク調整（目次用）
   * @returns
   */
  tableContentsScroll() {
    const urlHash = location.hash;
    if (urlHash && urlHash.startsWith('#a-toc')) {
      const target = $(urlHash == '#' || urlHash == '' ? 'html' : urlHash);
      let position = 0;
      let deviceType = Environment.getDeviceType();
      if (deviceType == 'pc') { // 目次の場合でかつPCの場合
        position = target.offset().top - 190;
      } else if (deviceType == 'sp') { // 目次の場合でかつSPの場合
        position = target.offset().top - $('.l-header').outerHeight();
      } else {
        position = target.offset().top;
      }
      const speed = 500;
      $('html, body').animate({
        scrollTop: position
      }, speed, 'swing');
      return false;
    }
  };
}
